import { validateEmail, validatePassword, validateConfirmPassword } from '../../utils/validations';
import { NewMembershipFormData } from '../models/NewJoinSessionData';

export interface RegistrationStatus {
  email: FieldStatus<string>;
  password: FieldStatus<string>;
  confirmPassword: FieldStatus<string>;
}

export interface FieldStatus<T> {
  value?: T;
  error: boolean;
  errorMessage: string | null;
  changed: boolean;
}

export const generateRegistrationStatus: (data?: NewMembershipFormData | undefined) => RegistrationStatus = (data) => {
  if (data === undefined) {
    return {
      email: { value: '', error: false, errorMessage: null, changed: false },
      password: { value: '', error: false, errorMessage: null, changed: false },
      confirmPassword: { value: '', error: false, errorMessage: null, changed: false },
    };
  }
  return {
    email: { value: data.email ?? '', error: false, errorMessage: null, changed: false },
    password: { value: data.password ?? '', error: false, errorMessage: null, changed: false },
    confirmPassword: { value: data.confirmPassword ?? '', error: false, errorMessage: null, changed: false },
  };
};

export const validateField: (
  field: string,
  value: string | null,
  data?: { password?: string; email?: string }
) => FieldStatus<string | null> | null = (field, value, data) => {
  let err: string | null = null;

  switch (field) {
    case 'email':
      const assignEmail: string = (value ?? '') as string;
      err = validateEmail(assignEmail);
      return { value: assignEmail, changed: true, error: err !== null, errorMessage: err };
    case 'password':
      const assignPassword: string = ((value ?? '') as string).substring(0, 31);
      err = validatePassword(assignPassword, data?.email ?? '');
      return { value: assignPassword, changed: true, error: err !== null, errorMessage: err };
    case 'confirmPassword':
      const assignConfirmPassword: string = ((value ?? '') as string).substring(0, 31);
      err = validateConfirmPassword(assignConfirmPassword, data?.password ?? '');
      return { value: assignConfirmPassword, changed: true, error: err !== null, errorMessage: err };
    default:
      return null;
  }
};

export const mapRegistrationDataOntoSessionData: (
  formStatus: RegistrationStatus,
  sessionFormData: NewMembershipFormData
) => NewMembershipFormData = (formStatus, sessionFormData) => {
  const outData: NewMembershipFormData = {
    ...sessionFormData,
    email: formStatus.email.value ?? null,
    password: formStatus.password.value ?? null,
    confirmPassword: formStatus.confirmPassword.value ?? null,
  };
  return outData;
};
